// components/Admin/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaTag, FaCode } from 'react-icons/fa'; // Импортируем иконки
import { FaUsersGear } from "react-icons/fa6";
import { IoSchool } from "react-icons/io5";

const Sidebar = () => {
  const location = useLocation(); // Получаем текущее местоположение

  return (
    <aside className="w-64 bg-white shadow-lg">
      <div className="p-4">
        <nav className="space-y-2">
          <Link 
            to="/admin" 
            className={`flex items-center p-3 text-gray-600 rounded-lg ${location.pathname === '/admin' || location.pathname === '/courses/add' ? 'bg-blue-50' : ''}`}
          >
            <FaHome className="mr-3" />
            Главная
          </Link>
          <Link 
            to="/admin/subjects" 
            className={`flex items-center p-3 text-gray-600 rounded-lg ${location.pathname === '/admin/subjects' ? 'bg-blue-50' : ''}`}
          >
            <IoSchool className="mr-3" /> {/* Иконка для промокодов */}
            Предметы
          </Link>
          <Link 
            to="/admin/users" 
            className={`flex items-center p-3 text-gray-600 rounded-lg ${location.pathname === '/admin/users' ? 'bg-blue-50' : ''}`}
          >
            <FaUsersGear className="mr-3" /> {/* Иконка для промокодов */}
            Список пользователей
          </Link>
          <Link 
            to="/admin/promocode" 
            className={`flex items-center p-3 text-gray-600 rounded-lg ${location.pathname === '/admin/promocode' ? 'bg-blue-50' : ''}`}
          >
            <FaTag className="mr-3" /> {/* Иконка для промокодов */}
            Промокоды
          </Link>
          <Link 
            to="/admin/scripts" 
            className={`flex items-center p-3 text-gray-600 rounded-lg ${location.pathname === '/admin/scripts' ? 'bg-blue-50' : ''}`}
          >
            <FaCode className="mr-3" /> {/* Иконка для скриптов */}
            Скрипты к чат-боту
          </Link>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
